import React, { FC } from 'react';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useDuration } from '@/scenarios/legacy-player/hooks/useDuration';

import { useNextEpisode } from '../../../../episode-player/hooks/use-next-episode';
import { isLastCredit } from '../../../utils/is-last-credit';

import { NextEpisodeSkipButtonGroup } from './component';

interface FilterProps {
    contentId: string;
    className?: string;
    currentFragment: SkippableFragment | undefined;
}

export const NextEpisodeSkipButtonGroupContainer: FC<FilterProps> = ({
    currentFragment,
    contentId,
    ...rest
}) => {
    const duration = useDuration();
    const hasNextEpisode = !!useNextEpisode(contentId);

    if (
        currentFragment &&
        currentFragment?.type === 'CREDITS' &&
        isLastCredit(currentFragment.endTime, duration) &&
        hasNextEpisode
    ) {
        return (
            <NextEpisodeSkipButtonGroup
                currentFragment={currentFragment}
                contentId={contentId}
                {...rest}
            />
        );
    }
    return null;
};
